import { Component } from "@angular/core";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { SplashFormService } from "projects/sepidz-web-framework-shell/src/lib/shared/splash-form/Splash-form.service";
import { SplashScreenService } from "projects/sepidz-web-framework-shell/src/lib/shared/splash-form/SplashScreenService";
import { ITab, TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { EntityListAction, Permission } from "projects/sepidz-web-framework/src/lib/models";
import { Datatransfer, VoucherKindInfo } from "projects/sepidz-web-framework/src/lib/models/datatransfer.model";
import { DialogType } from "projects/sepidz-web-framework/src/lib/models/dialog.enum";
import { EntityBase } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";
import { NameValue } from "projects/sepidz-web-framework/src/lib/models/name-value";
import { GridFilter, LookupService, Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { AccVoucherFormComponent } from "src/app/backoffice/acc/accvoucher/accvoucher-form/accvoucher-form.component";
import { TrsStatusKind } from "../../models/tresury.enums";
import { TrsVoucherHeader } from "../../models/trs-voucher-header.model";
import { TrsReferenceVoucherListComponent } from "../trs-reference-voucher-list/trs-reference-voucher-list.component";
import { TrsVoucherDetailFilterComponent } from "../trs-voucher-detail-filter/trs-voucher-detail-filter.component";
import { TrsVoucherFormComponent } from "../trs-voucher-form/trs-voucher-form.component";

@Component({
  selector: "ngx-trs-voucher-list",
  templateUrl: "./trs-voucher-list.component.html",
  styleUrls: ["./trs-voucher-list.component.scss"],
})
export class TrsVoucherListComponent extends BaseListComponent {
  filterInfo: NameValue[] = [];
  actions: EntityListAction[];
  filters: GridFilter[];
  constructor(
    private lookupservice: LookupService,
    private _tabsservice: TabularService,
    private splashScreenService: SplashScreenService,
    private splashFormService: SplashFormService
  ) {
    super();
    this.inputEditorform = TrsVoucherFormComponent;
    this.onActionClick = this.onActionClick.bind(this);
  }

  get currentFiscalYear() {
    return this.accountService.authService.currentFiscalYear;
  }
  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.filterInfo = undefined;
    this.actions = undefined;
    this.filters = undefined;
  }
  ngOnInit() {
    this.apiName = "TrsVoucherHeader/GetWithCustomFilter";
    this.label = "فهرست اسناد";
    this.areaName = "Treasury";
    this.setactions();
    if (this.currentFiscalYear) {
      this.filterInfo.push({ Name: "FiscalYearId", Value: this.currentFiscalYear?.Id, Operator: "eq" });
      this.filterInfo.push({ Name: "BranchId", Value: this.accountService.authService.currentBranchId, Operator: "eq" });
    } else
      this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
        if (x) {
          this.filterInfo.push({ Name: "FiscalYearId", Value: x.Id, Operator: "eq" });
          this.filterInfo.push({ Name: "BranchId", Value: this.accountService.authService.currentBranchId, Operator: "eq" });
        }
      });
  }
  async createAccVoucher(apiName: string, gridFilter: GridFilter[]) {
    this.splashFormService.openDialog("", "در حال صدور سند حسابداری");
    await this.httpCommonService
      .create(apiName, gridFilter)
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise()
      .then(
        (x) => {
          this.splashFormService.closeLoading();
          this._tabsservice.tabItemonRefreshData.next(this.apiName);
          this.sts.showDialog("اسناد با موفقیت صادر شد.", "");
        },
        (error) => {
          this.splashFormService.closeLoading();
          this.sts.showDialog(`خطا در صدور اسناد:${Utilities.getHttpResponseMessage(error)}`, "خطا");
        }
      );
  }
  async deleteAccVoucher(apiName: string, gridFilter: GridFilter[]) {
    this.splashFormService.openDialog("", "در حال حذف سند حسابداری");
    await this.httpCommonService
      .create(apiName, gridFilter)
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise()
      .then(
        (x) => {
          this.splashFormService.closeLoading();
          this._tabsservice.tabItemonRefreshData.next(this.apiName);
          this.sts.showDialog("اسناد با موفقیت حذف شد.", "");
        },
        (error) => {
          this.splashFormService.closeLoading();
          this.sts.showDialog(`خطا در حذف اسناد:${Utilities.getHttpResponseMessage(error)}`, "خطا");
        }
      );
  }
  onActionClick(
    action: EntityListAction,
    onRowSelected: TrsVoucherHeader,
    onRowsSelected: TrsVoucherHeader[],
    isAllSelected: boolean,
    gridFilter: GridFilter[]
  ) {
    if (onRowSelected && (!onRowsSelected || onRowsSelected.length <= 0)) onRowsSelected = [onRowSelected];
    let TrsVoucherHeaderIds: number[];
    ///نمایش سند حسابداری
    if (action.name === "ViewAccVoucher") {
      if (onRowSelected) {
        if (!onRowSelected.AccVoucherFixNumber) {
          this.sts.showDialog("سندحسابداری صادر نشده است.", "خطا");
          return;
        }
        this.httpCommonService
          .getItem("TrsVoucherHeader/ViewAccVoucher", onRowsSelected.length > 0 ? onRowsSelected[0].Id : onRowSelected.Id)
          .pipe(takeUntil(this.ngUnsubscribe))
          .toPromise()
          .then(
            (x) => {
              var datatrasfer: Datatransfer = <Datatransfer>{};
              datatrasfer.apiName = "AccVoucherHeader";
              datatrasfer.label = "صدور سند حسابداری";
              datatrasfer.areaName = "Accounting";
              datatrasfer.currentrow = x;
              const menu = <ITab>{
                title: `سند حسابداری-(نمایش)`,
                isCloseable: true,
                active: true,
                responsive: true,
                componentType: AccVoucherFormComponent,
                // modulePath: this._tabsservice.getActiveTab().modulePath,
                data: [
                  { provide: EntityBase, useValue: x },
                  { provide: Datatransfer, useValue: datatrasfer },
                  { provide: VoucherKindInfo, useValue: <VoucherKindInfo>{ VoucherKindId: x[""] } },
                ],
              };
              this._tabsservice.open(menu);
            },
            (error) => this.sts.showDialog(`خطا در نمایش سند:${Utilities.getHttpResponseMessage(error)}`, "خطا")
          );
      }
    }
    ///ایجاد سند حسابداری
    if (action.name === "CreateAccVoucher" || action.name === "DeleteAccVoucher") {
      if (onRowSelected) {
        if (onRowSelected.StatusKindCode < TrsStatusKind.Confirmed) {
          this.sts.showDialog("اسناد تایید نشده است.", "خطا");
          return;
        }
        if (!TrsVoucherHeaderIds) TrsVoucherHeaderIds = [];
        TrsVoucherHeaderIds.push(onRowSelected.Id);
      }
      if (onRowsSelected && onRowsSelected.length > 0) {
        if (onRowsSelected.some((x) => x.StatusKindCode < TrsStatusKind.Confirmed)) {
          this.sts.showDialog("اسناد تایید نشده است.", "خطا");
          return;
        }
        onRowsSelected.forEach((x) => {
          if (x) {
            if (!TrsVoucherHeaderIds) TrsVoucherHeaderIds = [];
            if (
              !TrsVoucherHeaderIds.some((id) => id === x.Id) &&
              x.HasJournalVoucher &&
              ((action.name === "CreateAccVoucher" && x.StatusKindCode === TrsStatusKind.Confirmed) ||
                (action.name === "DeleteAccVoucher" && x.StatusKindCode === TrsStatusKind.AccountRegistered))
            )
              TrsVoucherHeaderIds.push(x.Id);
          }
        });
      }
      let filter: GridFilter = {
        Type: "F",
        Filed: "TrsVoucherHeaderIds",
        Value: TrsVoucherHeaderIds,
        Logic: "and",
        Operator: "eq",
        Skip: 0,
        Take: 0,
      };
      if (TrsVoucherHeaderIds && TrsVoucherHeaderIds.length > 0) gridFilter.push(filter);

      if (action.name === "CreateAccVoucher") {
        if (gridFilter.length <= 0) {
          this.sts.showDialog("هیچ سندی انتخاب نشده یا اسناد انتخاب شده قابل صدور سند حسابداری نیست", "خطا");
          return;
        }
        this.sts.showDialog(
          "آیا از صدور سند حسابداری اطمینان دارید؟",
          "صدور سند",
          DialogType.confirm,
          async () => await this.createAccVoucher(action.apiName, gridFilter)
        );
      }
      if (action.name === "DeleteAccVoucher") {
        if (gridFilter.length <= 0) {
          this.sts.showDialog("هیچ سندی انتخاب نشده یا اسناد انتخاب شده قابل حذف نیست", "خطا");
          return;
        }
        this.sts.showDialog(
          "آیا از حذف سند حسابداری اطمینان دارید؟",
          "حذف سند",
          DialogType.confirm,
          async () => await this.deleteAccVoucher(action.apiName, gridFilter)
        );
      }
    }
    ///تایید اسناد
    if (action.name === "VoucherConFirmed" && onRowsSelected.length > 0) {
      onRowsSelected = onRowsSelected.filter((x) => x.StatusKindCode === TrsStatusKind.Registered);
      if (!onRowsSelected || onRowsSelected.length <= 0) {
        this.sts.showDialog("هیچ سندی انتخاب نشده یا اسناد انتخاب شده قابل تایید نیست", "خطا");
      }
      this.lookupservice
        .getLookupbyCode("TRS", "StatusKind", TrsStatusKind.Confirmed)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(async (sk) => {
          if (sk) {
            onRowsSelected.forEach((x) => {
              x.StatusKindId = sk.Id;
              x.StatusKindCode = sk.Code;
              x.StatusKindTitle = sk.Title;
            });
            await this.httpCommonService
              .bulkUpdate(action.apiName.split("/")[0], onRowsSelected)
              .pipe(takeUntil(this.ngUnsubscribe))
              .toPromise()
              .then(
                (x) => {
                  this._tabsservice.tabItemonRefreshData.next(this.apiName);
                  this.sts.showDialog("اسناد با موفقیت تایید شد.", "");
                },
                (error) => this.sts.showDialog(`خطا در تایید اسناد:${Utilities.getHttpResponseMessage(error)}`, "خطا")
              );
          }
        });
    }

    ///برگشت از تایید اسناد
    if (action.name === "VoucherDeConfirm" && onRowsSelected.length > 0) {
      onRowsSelected = onRowsSelected.filter((x) => x.StatusKindCode === TrsStatusKind.Confirmed);
      if (!onRowsSelected || onRowsSelected.length <= 0) {
        this.sts.showDialog("هیچ سندی انتخاب نشده یا وضعیت اسناد انتخاب شده تایید نیست", "خطا");
      }
      this.lookupservice
        .getLookupbyCode("TRS", "StatusKind", TrsStatusKind.Registered)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(async (sk) => {
          if (sk) {
            onRowsSelected.forEach((x) => {
              x.StatusKindId = sk.Id;
              x.StatusKindCode = sk.Code;
              x.StatusKindTitle = sk.Title;
            });
            await this.httpCommonService
              .bulkUpdate(action.apiName.split("/")[0], onRowsSelected)
              .pipe(takeUntil(this.ngUnsubscribe))
              .toPromise()
              .then(
                (x) => {
                  this._tabsservice.tabItemonRefreshData.next(this.apiName);
                  this.sts.showDialog("اسناد با موفقیت برگشت از تایید شد.", "");
                },
                (error) => this.sts.showDialog(`خطا در برگشت از تایید اسناد:${Utilities.getHttpResponseMessage(error)}`, "خطا")
              );
          }
        });
    }

    ///ابطال /برگشت از ابطال
    if (action.name === "VoucherCancelled" && onRowsSelected.length > 0) {
      let isCancelled: boolean = false;
      let onRowsSelected1 = onRowsSelected.filter((x) => x.StatusKindCode === TrsStatusKind.Registered);
      if (!onRowsSelected1 || onRowsSelected1.length <= 0) {
        onRowsSelected1 = onRowsSelected.filter((x) => x.StatusKindCode === TrsStatusKind.Cancelled);
        isCancelled = onRowsSelected1 && onRowsSelected1.length > 0;
      }
      if (!onRowsSelected1 || onRowsSelected1.length <= 0) {
        this.sts.showDialog("هیچ سندی انتخاب نشده یا وضعیت اسناد انتخاب شده ثبت اولیه نیست", "خطا");
        return;
      }
      this.lookupservice
        .getLookupbyCode("TRS", "StatusKind", isCancelled ? TrsStatusKind.Registered : TrsStatusKind.Cancelled)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(async (sk) => {
          if (sk) {
            onRowsSelected1.forEach((x) => {
              x.StatusKindId = sk.Id;
              x.StatusKindCode = sk.Code;
              x.StatusKindTitle = sk.Title;
            });
            await this.httpCommonService
              .bulkUpdate(action.apiName.split("/")[0], onRowsSelected1)
              .pipe(takeUntil(this.ngUnsubscribe))
              .toPromise()
              .then(
                (x) => {
                  this._tabsservice.tabItemonRefreshData.next(this.apiName);
                  if (isCancelled) this.sts.showDialog("اسناد با موفقیت برگشت از ابطال شد.", "");
                  else this.sts.showDialog("اسناد با موفقیت ابطال شد.", "");
                },
                (error) => this.sts.showDialog(`خطا در ابطال اسناد:${Utilities.getHttpResponseMessage(error)}`, "خطا")
              );
          }
        });
    }

    ///سند مبنا
    if (action.name === "TrsVoucherBase" && onRowSelected != null) {
      this.dialogService
        .open(
          TrsReferenceVoucherListComponent,
          {
            VoucherId: onRowsSelected.length > 0 ? onRowsSelected[0].Id : onRowSelected.Id,
            apiName: action.apiName,
            areaName: action.areaName,
            label: "سند مبنا",
          },
          {
            autoFocus: true,
            closeOnClickOutside: false,
            closeOnEscape: false,
          }
        )
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((model: any) => {});
    }
    ///سند معطوف
    if (action.name === "TrsRefrenceTo" && onRowSelected != null) {
      this.dialogService
        .open(
          TrsReferenceVoucherListComponent,
          {
            VoucherId: onRowsSelected.length > 0 ? onRowsSelected[0].Id : onRowSelected.Id,
            apiName: action.apiName,
            areaName: action.areaName,
            label: "سند معطوف",
          },
          {
            autoFocus: true,
            closeOnClickOutside: false,
            closeOnEscape: false,
          }
        )
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((model: any) => {});
    }
    ///فیلتر اقلام سند
    if (action.name === "TrsVoucherDetailFilter") {
      this.dialogService
        .open(
          TrsVoucherDetailFilterComponent,
          {
            currentrow: null,
            apiName: this.apiName,
            areaName: this.areaName,
            label: this.label,
          },
          {
            autoFocus: true,
            closeOnClickOutside: false,
          }
        )
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((model: GridFilter[]) => {
          if (model && model.length > 0) this.filters = model;
        });
    }
    ///حذف فیلتر افلام
    if (action.name === "TrsVoucherDetailFilterRemove") {
      this.filters = [];
    }
    return;
  }
  setactions() {
    this.actions = [
      {
        name: "CreateAccVoucher",
        disabled: false,
        displayName: "صدور سند حسابداری",
        iconName: "icon-create_new_folder-o",
        apiName: "TrsVoucherHeader/CreateAccVoucher",
        areaName: "Treasury",
        permission: Permission.samePermission,
      },
      {
        name: "DeleteAccVoucher",
        disabled: false,
        displayName: "حذف سند حسابداری",
        iconName: "icon-delete-sweep-outline",
        apiName: "TrsVoucherHeader/DeleteAccVoucher",
        areaName: "Treasury",
        permission: Permission.samePermission,
      },
      {
        name: "ViewAccVoucher",
        disabled: false,

        displayName: "نمایش سند حسابداری",
        iconName: "icon-table_view-f",
        apiName: "TrsVoucherHeader/ViewAccVoucher",
        areaName: "Treasury",
        permission: Permission.samePermission,
      },
      {
        name: "VoucherCancelled",
        disabled: false,
        displayName: "ابطال/برگشت از ابطال سند",
        iconName: "icon-blocked",
        apiName: "TrsVoucherHeader/VoucherCancelled",
        areaName: "Treasury",
        permission: Permission.samePermission,
      },
      {
        name: "VoucherConFirmed",
        disabled: false,
        displayName: "تائید سند",
        iconName: "icon-folder-open-outline",
        apiName: "TrsVoucherHeader/VoucherConFirmed",
        areaName: "Treasury",
        permission: Permission.samePermission,
      },
      {
        name: "VoucherDeConfirm",
        disabled: false,
        displayName: "برگشت از تائید",
        iconName: "icon-folder-open",
        apiName: "TrsVoucherHeader/VoucherDeConfirm",
        areaName: "Treasury",
        permission: Permission.samePermission,
      },
      {
        name: "TrsReportPrint",
        disabled: true,
        displayName: "چاپ سند",
        iconName: "icon-print-o",
        apiName: "TrsVoucherHeader/TrsReportPrint",
        areaName: "Treasury",
        permission: Permission.samePermission,
      },
      {
        name: "TrsRefrenceTo",
        disabled: false,
        displayName: "سند معطوف",
        iconName: "icon-content_copy-o",
        apiName: "TrsVoucherHeader/GetTrsReferenceToVouchersByVoucherId",
        areaName: "Treasury",
        permission: Permission.samePermission,
      },
      {
        name: "TrsVoucherBase",
        disabled: false,
        displayName: "سند مبنا",
        iconName: "icon-folder-open-outline",
        apiName: "TrsVoucherHeader/GetTrsReferenceVouchersByVoucherId",
        areaName: "Treasury",
        permission: Permission.samePermission,
      },
      {
        name: "TrsVoucherDetailFilter",
        disabled: false,
        displayName: "فیلتر اقلام",
        iconName: "icon-filter-variant-plus",
        apiName: "TrsVoucherHeader",
        areaName: "Treasury",
        permission: Permission.viewPermission,
      },
      {
        name: "TrsVoucherDetailFilterRemove",
        disabled: false,
        displayName: "حذف فیلتر اقلام",
        iconName: "icon-filter-variant-minus",
        apiName: "TrsVoucherHeader",
        areaName: "Treasury",
        permission: Permission.viewPermission,
      },
    ];
  }
}
